import React, { useState, useRef, useEffect } from "react";
import "./toolbar.css";
import logo from "../../images/logo.ico";
import {
  MdDashboard,
  MdMenu,
  MdNotifications,
  MdAssignment,
  MdDynamicFeed,
  MdOutlineCategory
} from "react-icons/md";
import { BsFillPeopleFill } from "react-icons/bs";
import { CgProfile } from "react-icons/cg";
import { FaPeopleCarry, FaAward, FaMoneyBillWave, FaFileInvoiceDollar, FaMoneyCheckAlt, FaUserSlash, FaMoneyBillAlt } from "react-icons/fa";
import { BiLogOut } from "react-icons/bi";
import { IoStorefrontOutline } from "react-icons/io5";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaBoxOpen } from "react-icons/fa";
import { FaList } from "react-icons/fa6";
import { ImInfo } from "react-icons/im";
const Toolbar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [pkExpensesOpen, setPkExpensesOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });
  const dropdownRef = useRef(null);
  const location = useLocation();

  const { user } = useSelector((state) => state.auth);

  const isAdmin = user?.type === "ADMIN";
  const allowedPages = isAdmin ? null : (user?.allowed_pages || []);

  const canSee = (key) => isAdmin || allowedPages.includes(key);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  // Map routes to link identifiers
  const getActiveLink = () => {
    const path = location.pathname;

    const routeMap = {
      '/admin/dashboard': 1,
      '/admin/orders': 4,
      '/admin/placeorders': 54,
      '/admin/monthly-invoices': 5,
      '/admin/posting': 18,
      '/admin/customers': 7,
      '/admin/inactive': 17,
      '/admin/staff': 8,
      '/admin/staf': 28,
      '/admin/category': 19,
      '/admin/products': 9,
      '/admin/feedbacks': 10,
      '/admin/question': 11,
      '/admin/pk-suppliers': 15,
      '/admin/lot': 14,
      '/admin/productList': 39, 
      '/admin/profile': 13,
      '/admin/currency': 55,
      '/admin/pk-expenses': 15,
      '/admin/bills': 15,
      '/admin/pk-purchase-orders': 15,
      '/admin/pk-mileage': 15,
      '/admin/details': 27,
    };

    // Find the matching route
    for (const [route, linkId] of Object.entries(routeMap)) {
      if (path.startsWith(route)) {
        return linkId;
      }
    }

    return 1; // Default to dashboard
  };

  const isActive = (linkId) => {
    return getActiveLink() === linkId;
  };

  const isPkExpensesActive = () => {
    const pkExpensesRoutes = [
      '/admin/pk-expenses',
      '/admin/bills',
      '/admin/pk-purchase-orders',
      '/admin/pk-suppliers',
      '/admin/pk-mileage'
    ];
    return pkExpensesRoutes.some(route => location.pathname.startsWith(route));
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setPkExpensesOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDropdownToggle = (e) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    setDropdownPos({
      top: rect.bottom + window.scrollY,
      left: rect.right + 10,
    });
    setPkExpensesOpen(!pkExpensesOpen);
  };

  const handleLinkClick = () => {
    setSidebarOpen(false);
    setPkExpensesOpen(false);
  };

  return (
    <>
      <button className="toolbar-mobile-menu-button" onClick={toggleSidebar}>
        <MdMenu size={24} />
      </button>
      {sidebarOpen && (
        <div className="toolbar-sidebar-overlay" onClick={toggleSidebar} />
      )}
      <div className={`toolbar-container ${sidebarOpen ? "open" : ""}`}>
        <div className="toolbar-brand">
          <img src={logo} alt="logo" />
        </div>

        <div className="toolbar-links">
          <ul>
            {canSee("dashboard") && (
              <li className={isActive(1) ? "active" : ""}>
                <Link to="/admin/dashboard" onClick={handleLinkClick}><MdDashboard /> <span> Dashboard </span></Link>
              </li>
            )}
            {/* Currency Settings Page Link */}
            {canSee("currency") && (
              <li className={isActive(55) ? "active" : ""}>
                <Link to="/admin/currency" onClick={handleLinkClick}><FaMoneyBillAlt /> <span> Currency Settings </span></Link>
              </li>
            )}
              {canSee("invoice-information") && (
              <li className={isActive(27) ? "active" : ""}>
                <Link to="/admin/details" onClick={handleLinkClick}><ImInfo /> <span> Invoice Details </span></Link>
              </li>
            )}
                        {canSee("place-orders") && (
              <li className={isActive(54) ? "active" : ""}>
                <Link to="/admin/placeorders" onClick={handleLinkClick}><FaBoxOpen /> <span> Place Orders </span></Link>
              </li>
            )}

            {canSee("orders") && (
              <li className={isActive(4) ? "active" : ""}>
                <Link to="/admin/orders" onClick={handleLinkClick}><MdAssignment /> <span> Orders </span></Link>
              </li>
            )}


            {canSee("monthly-invoices") && (
              <li className={isActive(5) ? "active" : ""}>
                <Link to="/admin/monthly-invoices" onClick={handleLinkClick}><FaFileInvoiceDollar /> <span> Statements </span></Link>
              </li>
            )}

            {canSee("posting") && (
              <li className={isActive(18) ? "active" : ""}>
                <Link to="/admin/posting" onClick={handleLinkClick}><FaMoneyCheckAlt /> <span> Postings </span></Link>
              </li>
            )}

            {canSee("customers") && (
              <li className={isActive(7) ? "active" : ""}>
                <Link to="/admin/customers" onClick={handleLinkClick}><BsFillPeopleFill /> <span> Customers </span></Link>
              </li>
            )}

            {canSee("inactive") && (
              <li className={isActive(17) ? "active" : ""}>
                <Link to="/admin/inactive" onClick={handleLinkClick}><FaUserSlash /> <span> Inactive Customers </span></Link>
              </li>
            )}

            {/* {canSee("staff") && (
              <li className={isActive(8) ? "active" : ""}>
                <Link to="/admin/staff" onClick={handleLinkClick}><FaPeopleCarry /> <span> Members </span></Link>
              </li>
            )} */}

            {canSee("staf") && (
              <li className={isActive(28) ? "active" : ""}>
                <Link to="/admin/staf" onClick={handleLinkClick}><FaPeopleCarry /> <span> Staff Members </span></Link>
              </li>
            )}

            {canSee("category") && (
              <li className={isActive(19) ? "active" : ""}>
                <Link to="/admin/category" onClick={handleLinkClick}><MdOutlineCategory /> <span> Categories </span></Link>
              </li>
            )}

            {canSee("products") && (
              <li className={isActive(9) ? "active" : ""}>
                <Link to="/admin/products" onClick={handleLinkClick}><IoStorefrontOutline /> <span> Products </span></Link>
              </li>
            )}
{canSee("products") && (
              <li className={isActive(39) ? "active" : ""}>
                <Link to="/admin/productList" onClick={handleLinkClick}><FaList/> <span> Product List </span></Link>
              </li>
            )}
            {/*{canSee("feedbacks") && (*/}
            {/*  <li className={isActive(10) ? "active" : ""}>*/}
            {/*    <Link to="/admin/feedbacks" onClick={handleLinkClick}><MdDynamicFeed /> <span> Reviews </span></Link>*/}
            {/*  </li>*/}
            {/*)}*/}

            {canSee("question") && (
              <li className={isActive(11) ? "active" : ""}>
                <Link to="/admin/question" onClick={handleLinkClick}><MdNotifications /> <span> Messages </span></Link>
              </li>
            )}

            {/*{canSee("expenses-uk") && (*/}
            {/*  <li className={`toolbar-has-submenu ${isPkExpensesActive() ? "active" : ""}`}>*/}
            {/*    <div className="toolbar-dropdown-toggle">*/}
            {/*      <FaMoneyBillWave className="expense-icon" />*/}
            {/*      <Link to="/admin/pk-suppliers" onClick={handleLinkClick}>*/}
            {/*        <span>Uk Expense</span>*/}
            {/*      </Link>*/}
            {/*      <span className={`toolbar-arrow ${pkExpensesOpen ? "open" : ""}`} onClick={handleDropdownToggle}>*/}
            {/*        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">*/}
            {/*          <polyline points="6 9 12 15 18 9"/>*/}
            {/*        </svg>*/}
            {/*      </span>*/}
            {/*    </div>*/}
            {/*  </li>*/}
            {/*)}*/}

            {canSee("lot") && (
              <li className={isActive(14) ? "active" : ""}>
                <Link to="/admin/lot" onClick={handleLinkClick}><FaAward /> <span> Lot Tracking Record </span></Link>
              </li>
            )}

            {canSee("profile") && (
              <li className={isActive(13) ? "active" : ""}>
                <Link to="/admin/Profile" onClick={handleLinkClick}><CgProfile /> <span> Profile </span></Link>
              </li>
            )}



            {/* Logout hamesha dikhega */}
            <li>
              <Link to="/logout" onClick={handleLinkClick}><BiLogOut /> <span> Log Out </span></Link>
            </li>
          </ul>
        </div>
      </div>

      {/*{canSee("expenses-uk") && pkExpensesOpen && (*/}
      {/*  <ul ref={dropdownRef} className="toolbar-dropdown-menu active" style={{*/}
      {/*    position: "fixed",*/}
      {/*    top: dropdownPos.top,*/}
      {/*    left: dropdownPos.left,*/}
      {/*    zIndex: 9999,*/}
      {/*    backgroundColor: "#fff",*/}
      {/*    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",*/}
      {/*    padding: "10px",*/}
      {/*    borderRadius: "4px",*/}
      {/*  }}>*/}
      {/*    <li><Link to="/admin/pk-expenses" onClick={handleLinkClick}>Expenses</Link></li>*/}
      {/*    <li><Link to="/admin/bills" onClick={handleLinkClick}>Bills</Link></li>*/}
      {/*    <li><Link to="/admin/pk-purchase-orders" onClick={handleLinkClick}>Purchase Orders</Link></li>*/}
      {/*    <li><Link to="/admin/pk-suppliers" onClick={handleLinkClick}>Suppliers</Link></li>*/}
      {/*    <li><Link to="/admin/pk-mileage" onClick={handleLinkClick}>Mileage</Link></li>*/}
      {/*  </ul>*/}
      {/*)}*/}
    </>
  );
};

export default Toolbar;